<template>
  <RF-Dialog
    :cpntStatus='statusGeral'
    :cpntLargura='"400px"'

    :cpntOnFecharDialog='proFormEstAjusteNovoFechar'>
    <template slot='titulo'>
      <!-- SETA O ICONE DO CAMPO -->
      <i aria-hidden="true" class="fa fa-angle-double-right"></i>

      <!-- SETA O TITULO DA ABA -->
      Novo ajuste de estoque para produto
    </template>

    <template slot='conteudo'>
      <div class="pro-form-est-ajuste">
        <div>
          <App-Input :data-time="time" class="pro-form-est-aju--qtde_ajuste" 
          :cpntStatus='campos.qtde_ajuste.status'
          :cpntId='campos.qtde_ajuste.id'
          :class='campos.qtde_ajuste.class'
          :cpntTabIndex='campos.qtde_ajuste.tabIndex'
          :cpntClassDivField='campos.qtde_ajuste.classDivField'
          :cpntNome='campos.qtde_ajuste.nome'
          :cpntValue='campos.qtde_ajuste.value'
          :cpntAutoComplete='campos.qtde_ajuste.autocomplete'
          :cpntMask='campos.qtde_ajuste.mask'
          :cpntOptionInicialNome='campos.qtde_ajuste.optionInicialNome'
          :cpntOptionInicialValue='campos.qtde_ajuste.optionInicialValue'
          :cpntDisabled='campos.qtde_ajuste.disabled'
          :cpntMostrar='campos.qtde_ajuste.mostrar'
          :cpntAutoFocus='campos.qtde_ajuste.autofocus'
          :cpntMensagem='campos.qtde_ajuste.mensagem'
          :cpntMensagemTipo='campos.qtde_ajuste.mensagemTipo'
          :cpntPlaceholder='campos.qtde_ajuste.placeholder'
          :cpntPosicionar='campos.qtde_ajuste.posicionar'
          :cpntOnChange='campos.qtde_ajuste.onChange'
          :cpntOnBlur='campos.qtde_ajuste.onBlur'
          ref='qtde_ajuste'
          ></App-Input>

          <App-Input :data-time="time" class="pro-form-est-aju--qtde_estoque" 
          :cpntStatus='campos.qtde_estoque.status'
          :cpntId='campos.qtde_estoque.id'
          :class='campos.qtde_estoque.class'
          :cpntTabIndex='campos.qtde_estoque.tabIndex'
          :cpntClassDivField='campos.qtde_estoque.classDivField'
          :cpntNome='campos.qtde_estoque.nome'
          :cpntValue='campos.qtde_estoque.value'
          :cpntAutoComplete='campos.qtde_estoque.autocomplete'
          :cpntMask='campos.qtde_estoque.mask'
          :cpntOptionInicialNome='campos.qtde_estoque.optionInicialNome'
          :cpntOptionInicialValue='campos.qtde_estoque.optionInicialValue'
          :cpntDisabled='campos.qtde_estoque.disabled'
          :cpntMostrar='campos.qtde_estoque.mostrar'
          :cpntAutoFocus='campos.qtde_estoque.autofocus'
          :cpntMensagem='campos.qtde_estoque.mensagem'
          :cpntMensagemTipo='campos.qtde_estoque.mensagemTipo'
          :cpntPlaceholder='campos.qtde_estoque.placeholder'
          :cpntPosicionar='campos.qtde_estoque.posicionar'
          :cpntOnChange='campos.qtde_estoque.onChange'
          :cpntOnBlur='campos.qtde_estoque.onBlur'
          ref='qtde_estoque'
          ></App-Input>
        </div><div>
          <App-Input :data-time="time" class="pro-form-est-aju--valor_unitario" 
          :cpntStatus='campos.valor_unitario.status'
          :cpntId='campos.valor_unitario.id'
          :class='campos.valor_unitario.class'
          :cpntTabIndex='campos.valor_unitario.tabIndex'
          :cpntClassDivField='campos.valor_unitario.classDivField'
          :cpntNome='campos.valor_unitario.nome'
          :cpntValue='campos.valor_unitario.value'
          :cpntAutoComplete='campos.valor_unitario.autocomplete'
          :cpntMask='campos.valor_unitario.mask'
          :cpntOptionInicialNome='campos.valor_unitario.optionInicialNome'
          :cpntOptionInicialValue='campos.valor_unitario.optionInicialValue'
          :cpntDisabled='campos.valor_unitario.disabled'
          :cpntMostrar='campos.valor_unitario.mostrar'
          :cpntAutoFocus='campos.valor_unitario.autofocus'
          :cpntMensagem='campos.valor_unitario.mensagem'
          :cpntMensagemTipo='campos.valor_unitario.mensagemTipo'
          :cpntPlaceholder='campos.valor_unitario.placeholder'
          :cpntPosicionar='campos.valor_unitario.posicionar'
          :cpntOnChange='campos.valor_unitario.onChange'
          :cpntOnBlur='campos.valor_unitario.onBlur'
          ref='valor_unitario'
          ></App-Input>
         
          <div class="pro-form-est-aju--estoque_data_movimento">
            <App-Calendario :data-time="time" class="pro-form-est-aju--est_mov_data" 
            :cpntStatus='campos.est_mov_data.status'
            :cpntId='campos.est_mov_data.id'
            :cpntClassDivField='campos.est_mov_data.classDivField'
            :cpntNome='campos.est_mov_data.nome'
            :cpntValue='campos.est_mov_data.value'
            :cpntAutoComplete='campos.est_mov_data.autocomplete'
            :cpntMask='campos.est_mov_data.mask'
            :cpntDisabled='campos.est_mov_data.disabled'
            :cpntMostrar='campos.est_mov_data.mostrar'
            :cpntAutoFocus='campos.est_mov_data.autofocus'
            :cpntMensagem='campos.est_mov_data.mensagem'
            :cpntMensagemTipo='campos.est_mov_data.mensagemTipo'
            :cpntPlaceholder='campos.est_mov_data.placeholder'
            :cpntExplica='campos.est_mov_data.explica'
            :cpntConfig='campos.est_mov_data.config'
            :cpntPosicionar='campos.est_mov_data.posicionar'
            :cpntTabIndex='campos.est_mov_data.tabIndex'
  
            :cpntOnChange='campos.est_mov_data.onChange'
            ref='est_mov_data'
            ></App-Calendario>
              
            <App-Select :data-time="time" class="pro-form-est-aju--est_mov_hora"
            :cpntStatus='campos.est_mov_hora.status'
            :cpntId='campos.est_mov_hora.id'
            :cpntTabIndex='campos.est_mov_hora.tabIndex'
            :cpntNome='campos.est_mov_hora.nome'
            :cpntValue='campos.est_mov_hora.value'
            :cpntMensagem='campos.est_mov_hora.mensagem'
            :cpntMensagemTipo='campos.est_mov_hora.mensagemTipo'
            :cpntDisabled='campos.est_mov_hora.disabled'
            :cpntMostrar='campos.est_mov_hora.mostrar'
            :cpntExplica='campos.est_mov_hora.explica'
            :cpntPlaceholder='campos.est_mov_hora.placeholder'
            :cpntValueRef='campos.est_mov_hora.valueRef'
            :cpntRouter='campos.est_mov_hora.router'
            :cpntField='campos.est_mov_hora.field'
            :cpntWhere='campos.est_mov_hora.where'
            :cpntAddButForm='campos.est_mov_hora.addButForm'
            :cpntKeyMostra='campos.est_mov_hora.keyMostra'
            :cpntTipoOrder='campos.est_mov_hora.tipoOrder'
            :cpntOrder='campos.est_mov_hora.order'
            :cpntOptions='campos.est_mov_hora.options'
            :cpntKeyValue='campos.est_mov_hora.keyValue'
            :cpntSearchMinimo='campos.est_mov_hora.searchMinimo'
            :cpntMask='campos.est_mov_hora.mask'
            :cpntOptionInicialNome='campos.est_mov_hora.optionInicialNome'
            :cpntOptionInicialValue='campos.est_mov_hora.optionInicialValue'
  
            :cpntOnChange='campos.est_mov_hora.onChange'
            :cpntOnBlur='campos.est_mov_hora.onBlur'
            :cpntOnRealizaBusca='campos.est_mov_hora.onRealizaBusca'
            :cpntOnKeyPressEnter='campos.est_mov_hora.onKeyPressEnter'
            ref="est_mov_hora"
            ></App-Select>
  
            <App-Select :data-time="time" class="pro-form-est-aju--est_mov_minu"
            :cpntStatus='campos.est_mov_minu.status'
            :cpntId='campos.est_mov_minu.id'
            :cpntTabIndex='campos.est_mov_minu.tabIndex'
            :cpntNome='campos.est_mov_minu.nome'
            :cpntValue='campos.est_mov_minu.value'
            :cpntMensagem='campos.est_mov_minu.mensagem'
            :cpntMensagemTipo='campos.est_mov_minu.mensagemTipo'
            :cpntDisabled='campos.est_mov_minu.disabled'
            :cpntMostrar='campos.est_mov_minu.mostrar'
            :cpntExplica='campos.est_mov_minu.explica'
            :cpntPlaceholder='campos.est_mov_minu.placeholder'
            :cpntValueRef='campos.est_mov_minu.valueRef'
            :cpntRouter='campos.est_mov_minu.router'
            :cpntField='campos.est_mov_minu.field'
            :cpntWhere='campos.est_mov_minu.where'
            :cpntAddButForm='campos.est_mov_minu.addButForm'
            :cpntKeyMostra='campos.est_mov_minu.keyMostra'
            :cpntTipoOrder='campos.est_mov_minu.tipoOrder'
            :cpntOrder='campos.est_mov_minu.order'
            :cpntOptions='campos.est_mov_minu.options'
            :cpntKeyValue='campos.est_mov_minu.keyValue'
            :cpntSearchMinimo='campos.est_mov_minu.searchMinimo'
            :cpntMask='campos.est_mov_minu.mask'
            :cpntOptionInicialNome='campos.est_mov_minu.optionInicialNome'
            :cpntOptionInicialValue='campos.est_mov_minu.optionInicialValue'
  
            :cpntOnChange='campos.est_mov_minu.onChange'
            :cpntOnBlur='campos.est_mov_minu.onBlur'
            :cpntOnRealizaBusca='campos.est_mov_minu.onRealizaBusca'
            :cpntOnKeyPressEnter='campos.est_mov_minu.onKeyPressEnter'
            ref="est_mov_minu"
            ></App-Select>
          </div>
        </div><div>
          <App-Textarea :data-time="time" class="pro-form-est-aju--observacao"
          :cpntStatus='campos.observacao.status'
          :cpntId='campos.observacao.id'
          :cpntTabIndex='campos.observacao.tabIndex'
          :cpntClassDivField='campos.observacao.classDivField'
          :cpntNome='campos.observacao.nome'
          :cpntValue='campos.observacao.value'
          :cpntAutoComplete='campos.observacao.autocomplete'
          :cpntMask='campos.observacao.mask'
          :cpntOptionInicialNome='campos.observacao.optionInicialNome'
          :cpntOptionInicialValue='campos.observacao.optionInicialValue'
          :cpntDisabled='campos.observacao.disabled'
          :cpntMostrar='campos.observacao.mostrar'
          :cpntAutoFocus='campos.observacao.autofocus'
          :cpntMensagem='campos.observacao.mensagem'
          :cpntMensagemTipo='campos.observacao.mensagemTipo'
          :cpntPlaceholder='campos.observacao.placeholder'
          :cpntPosicionar='campos.observacao.posicionar'
          :cpntOnChange='campos.observacao.onChange'
          :cpntOnBlur='campos.observacao.onBlur'
          ref='observacao'
          ></App-Textarea>
        </div>
      </div>
    </template>

    <template slot="rodape">
      <div class="pro-form-est-ajuste-bts">
        <App-Button :data-time='time'
          :cpntStatus='botoes.cancelar.status' 
          :cpntId='botoes.cancelar.id' 
          :cpntTexto='botoes.cancelar.texto' 
          :cpntClass='botoes.cancelar.class'
          :cpntMostrar='botoes.cancelar.mostrar'
          :cpntTabIndex='botoes.cancelar.tabIndex'
          @onClick='botoes.cancelar.onClick'
        ></App-Button>
        
        <App-Button :data-time='time'
          :cpntStatus='botoes.salvar.status' 
          :cpntId='botoes.salvar.id' 
          :cpntTexto='botoes.salvar.texto' 
          :cpntClass='botoes.salvar.class'
          :cpntMostrar='botoes.salvar.mostrar'
          :cpntTabIndex='botoes.salvar.tabIndex'
          @onClick='botoes.salvar.onClick'
        ></App-Button>
      </div>
    </template>
  </RF-Dialog>
</template>

<style scoped>
.pro-form-est-ajuste {
  width: 100%;
  padding-top: 15px;
  text-align: left;
}
  .pro-form-est-ajuste > div:not(:first-child) {
    padding-top: 22px;
  }
  .pro-form-est-ajuste > div,
  .pro-form-est-ajuste > div > div {
    width: 100%;
  }
  .pro-form-est-ajuste > div > .pro-form-est-aju--qtde_ajuste,
  .pro-form-est-ajuste > div > .pro-form-est-aju--qtde_estoque {
    width: calc((100% - 10px) / 2);
  }
  .pro-form-est-ajuste > div > .pro-form-est-aju--valor_unitario {
    width: 130px;
  }
  .pro-form-est-ajuste > div > .pro-form-est-aju--estoque_data_movimento {
    width: calc(100% - 142px);
    display: inline-block;
  }
  .pro-form-est-ajuste > div > div > .pro-form-est-aju--est_mov_data {
    width: calc(100% - 10px - 104px);
  }
    .pro-form-est-ajuste > div > div > .pro-form-est-aju--est_mov_hora,
    .pro-form-est-ajuste > div > div > .pro-form-est-aju--est_mov_minu {
      display: inline-block;
      width: 52px;
      margin-left: 5px;
    }
    .pro-form-est-ajuste > div > .pro-form-est-aju--qtde_ajuste,
  .pro-form-est-ajuste > div > .pro-form-est-aju--valor_unitario {
    margin-right: 10px;
  }
  .pro-form-est-ajuste-bts {
    width: calc(100%);
    margin-top: 10px;
    text-align: right;
  }
    .pro-form-est-ajuste-bts > button {
      margin: 0px 5px;
    }
</style>

<style>
</style>

<script>
  // IMPORTA BIBLIOTECA DEPENDENTE
  var moment = require('moment')

  export default {
    props: {
      cpntHashId: {
        required: true
      },
      cpntId: {
        required: false,
        default: function () {
          return null
        }
      },
      cpntIdPro: {
        required: true
      },
      cpntDados: {
        required: false,
        default: function () {
          return null
        }
      },
      cpntProduto: {
        required: false,
        default: function () {
          return null
        }
      },

      cpntFecharFormulario: {
        required: true
      }
    },
    data: function () {
      return {
        time: '',
        statusGeral: 'carregando',
        campos: {
          qtde_ajuste: {
            id: this.cpntHashId + '--qtde_ajuste',
            status: '',
            class: '',
            tabIndex: 6004001,
            nome: 'Qtde a ser ajustada',
            value: '',
            valueIni: '',
            mask: 'VALOR_DECIMAL_CAMPO',
            apiEnv: 'qtde_ajuste',
            trava: null,
            onChange: this.proFormEstAjusteNovoOnChangeValue
          },
          qtde_estoque: {
            id: this.cpntHashId + '--qtde_estoque',
            status: '',
            class: '',
            tabIndex: 6004001,
            nome: 'Estoque ficará com',
            value: '',
            valueIni: '',
            mask: 'VALOR_DECIMAL_CAMPO',
            trava: null,
            onChange: this.proFormEstAjusteNovoOnChangeValue
          },
          valor_unitario: {
            id: this.cpntHashId + '--valor_unitario',
            status: '',
            class: '',
            tabIndex: 6004002,
            nome: 'Valor do custo/venda',
            value: '0,00',
            valueIni: '',
            mask: 'valorDecimalNovo',
            apiEnv: 'valor_unitario',
            onChange: this.proFormEstAjusteNovoOnChangeValue
          },          
          est_mov_data: {
            id: this.cpntHashId + '--est_mov_data',
            status: '',
            tabIndex: 6004003,
            nome: 'Data',
            config: { dateFormat: 'dd/mm/yyyy' },
            value: '',
            onChange: this.proFormEstAjusteNovoOnChangeValue
          },
          est_mov_hora: {
            id: this.cpntHashId + '--est_mov_hora',
            status: '',
            tabIndex: 6004004,
            nome: 'Hora',
            keyValue: 'id',
            keyMostra: [ 'id' ],
            options: [ { id: '00' }, { id: '01' }, { id: '02' }, { id: '03' }, { id: '04' }, { id: '05' }, { id: '06' }, { id: '07' }, { id: '08' }, { id: '09' }, { id: '10' }, { id: '11' }, { id: '12' }, { id: '13' }, { id: '14' }, { id: '15' }, { id: '16' }, { id: '17' }, { id: '18' }, { id: '19' }, { id: '20' }, { id: '21' }, { id: '22' }, { id: '23' } ],
            value: '',
            onChange: this.proFormEstAjusteNovoOnChangeValue
          },
          est_mov_minu: {
            id: this.cpntHashId + '--est_mov_minu',
            status: '',
            tabIndex: 6004005,
            nome: 'Minuto',
            keyValue: 'id',
            keyMostra: [ 'id' ],
            options: [ { id: '00' }, { id: '01' }, { id: '02' }, { id: '03' }, { id: '04' }, { id: '05' }, { id: '06' }, { id: '07' }, { id: '08' }, { id: '09' }, { id: '10' }, { id: '11' }, { id: '12' }, { id: '13' }, { id: '14' }, { id: '15' }, { id: '16' }, { id: '17' }, { id: '18' }, { id: '19' }, { id: '20' }, { id: '21' }, { id: '22' }, { id: '23' }, { id: '24' }, { id: '25' }, { id: '26' }, { id: '27' }, { id: '28' }, { id: '29' }, { id: '30' }, { id: '31' }, { id: '32' }, { id: '33' }, { id: '34' }, { id: '35' }, { id: '36' }, { id: '37' }, { id: '38' }, { id: '39' }, { id: '40' }, { id: '41' }, { id: '42' }, { id: '43' }, { id: '44' }, { id: '45' }, { id: '46' }, { id: '47' }, { id: '48' }, { id: '49' }, { id: '50' }, { id: '51' }, { id: '52' }, { id: '53' }, { id: '54' }, { id: '55' }, { id: '56' }, { id: '57' }, { id: '58' }, { id: '59' } ],
            value: '',
            onChange: this.proFormEstAjusteNovoOnChangeValue
          },

          observacao: {
            id: this.cpntHashId + '--observacao',
            status: '',
            class: '',
            tabIndex: 6004006,
            nome: 'Observação',
            value: '',
            valueIni: '',
            apiEnv: 'observacao',
            onChange: this.proFormEstAjusteNovoOnChangeValue
          },
        },
        botoes: {
          salvar: {
            status: '',
            tabIndex: 6004010,
            id: 'dem-edi-pro-form--salvar',
            texto: (this.cpntId === 0 ? 'Salvar' : 'Atualizar'),
            class: [ 'btn', 'btn-primary' ],
            mostrar: true,
            onClick: () => { this.proFormEstAjusteNovoInserir() }
          },
          cancelar: {
            status: '',
            tabIndex: 6004011,
            id: 'dem-edi-pro-form--cancelar',
            texto: 'Cancelar',
            class: [ 'btn', 'btn-default', 'btn-sm' ],
            mostrar: true,
            onClick: () => { this.proFormEstAjusteNovoFechar(false) }
          }
        }
      }
    },
    mounted: function () {
      this.proFormEstAjusteNovoIniciar()
    },
    methods: {
      proFormEstAjusteNovoFechar: function (atualizar) {
        this.cpntFecharFormulario(atualizar)
      },
      proFormEstAjusteNovoSetarStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      proFormEstAjusteNovoIniciar: function () {
        // SETA O STATUS DA PAGINA
        this.proFormEstAjusteNovoSetarStatusGeral('carregando')

        // VERIFICA S ETEM QUE BUSCAR OS DADOS
        new Promise((success) => {
          if ([ '', null, undefined ].indexOf(this.cpntDados) === -1) {
            success(this.cpntDados)
          } else if ([ '', null, undefined, '0', 0 ].indexOf(this.cpntId) === -1) {
            // SETA O QUERY GET NA API
            var queryGet = { type: 'list', limit: { row: 0, qty: 1 }, where: { f: 'id', o: '=', v: this.cpntId } }

            // SETA OS CAMPOS QUE DEVE BUSCAR
            queryGet.field = {
              id: null,
              id_pro: null,
              qtde_ajuste: null,
              valor_unitario: null,
              valor_total: null,
              estoque_data_movimento: null,
              observacao: null,
              created_user: null,
              created_at: null,
              updated_user: null,
              updated_at: null,
              deleted_user: null,
              deleted_at: null,
              last_user: null,
              last_at: null,
              status: null,
            }

            // COMUNICA COM A API
            this.$store.state.comunicaAPI('/produto/estoque/ajuste/get', 'POST', queryGet, (retorno) => {
              success(retorno.data[0])
            }, this.proFormEstAjusteNovoSetarStatusGeral)
          } else {
            success(null)
          }
        }).then((retorno) => {
          if (retorno !== null) {
            // PEGA O NOME DE CADA CHAVE QUE DEVE SETAR O VALOR
            var chaves = Object.keys(this.campos)
  
            // RODA O VETOR DOS CAMPOS
            for (var indexC in chaves) {
              // SETA O NOME DA CHAVE QUE SERÁ TRABALHADA
              var chave = chaves[indexC]
  
              // SETA OS VALORES DO CAMPO
              this.proFormEstAjusteNovoSetarValorCampo(chave, retorno)
            }
          } else {
            // SETA O VALOR INICIAL DO CAMPO
            this.proFormEstAjusteNovoSetarValorCampo('est_mov_data')
            this.proFormEstAjusteNovoSetarValorCampo('est_mov_hora')
            this.proFormEstAjusteNovoSetarValorCampo('est_mov_minu')
          }

          // SETA O FOCUS NO CAMPO
          this.proFormEstAjusteNovoRealizarFocusCampo('qtde_ajuste')

          // SETA O STATUS DA TELA
          this.proFormEstAjusteNovoSetarStatusGeral('')
        })
      },
      proFormEstAjusteNovoSetarValorCampo: function (chave, dados = {}, ini = false) {
        // INICIA A VARIAVEL DE VALOR
        var value = ''
        var valueIni = ''
        var valueRef = ''
        var options = null

        // VERIFICA SE TEM ALGUM VALOR PREENCHIDO
        var dataMovi = [ '', null, undefined ].indexOf(dados.estoque_data_movimento_ptbr) === -1 ? dados.estoque_data_movimento_ptbr : moment(this.$store.state.dadosApi.datetime, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm:ss')

        // VERIFICA O VALOR QUE DEVE SELECIONAR
        switch (chave) {
          case 'qtde_ajuste':
            // CARREGA O VALOR DO CAMPO
            value = [ '', null, undefined ].indexOf(dados[chave]) === -1 ? dados[chave] : ''
            
            // FORMATA O VALOR INICIAL
            valueIni = this.proFormEstAjusteNovoConverteEmNumero(JSON.parse(JSON.stringify(value)))
            break
            
          case 'qtde_estoque':
            // INICIA A VARRIAVEL
            var estoque = this.cpntProduto.virtual_qtde_estoque.estoque

            // CALCULA O ESTOQUE
            if ([ '', null, undefined, '0', 0 ].indexOf(this.cpntId) === -1) {
              estoque = (Number(this.cpntProduto.virtual_qtde_estoque.estoque) - Number(dados.qtde_ajuste)).toString()
            }

            // CARREGA O VALOR DO CAMPO
            value = estoque

            // PEGA O VALOR INICIAL
            valueIni = JSON.parse(JSON.stringify(value))
            
            // FORMATA O VALOR INICIAL
            valueIni = this.proFormEstAjusteNovoConverteEmNumero(JSON.parse(JSON.stringify(value)))
            break

          case 'valor_unitario':
            // CARREGA O VALOR DO CAMPO
            value = [ '', null, undefined ].indexOf(dados[chave]) === -1 ? dados[chave] : ''

            // FORMATA O VALOR RECEBIDO
            value = this.$store.state.FUN_MASK_VALOR('valorDecimalNovo', value)
            break

          case 'est_mov_data':
            if (ini === false || (ini === true && [ '', null, undefined ].indexOf(dados.estoque_data_movimento_ptbr) === -1)) {
              // REMOVE A PALAVRA AS
              value = JSON.parse(JSON.stringify(dataMovi)).replace(' às ', ' ')
  
              // FORMATA O VALOR
              if (value !== '') {
                value = moment(value, 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY')
              }
            }
            break

          case 'est_mov_hora':
            if (ini === false || (ini === true && [ '', null, undefined ].indexOf(dados.estoque_data_movimento_ptbr) === -1)) {
              // REMOVE A PALAVRA AS
              value = JSON.parse(JSON.stringify(dataMovi)).replace(' às ', ' ')

              // FORMATA O VALOR
              if (value !== '') {
                value = moment(value, 'DD/MM/YYYY HH:mm:ss').format('HH')
              }
            }
            break

          case 'est_mov_minu':
            if (ini === false || (ini === true && [ '', null, undefined ].indexOf(dados.estoque_data_movimento_ptbr) === -1)) {
              // REMOVE A PALAVRA AS
              value = JSON.parse(JSON.stringify(dataMovi)).replace(' às ', ' ')

              // FORMATA O VALOR
              if (value !== '') {
                value = moment(value, 'DD/MM/YYYY HH:mm:ss').format('mm')
              }
            }
            break

          default:
            value = [ '', null, undefined ].indexOf(dados[chave]) === -1 ? dados[chave] : ''
            break
        }

        // PEGA OS OPTIONS DO CAMPO
        if (options === null && [ '', null, undefined ].indexOf(this.campos[chave].options) === -1 && this.campos[chave].options.length >= 1) {
          options = this.campos[chave].options
        }

        // VERIFICA SE TEM OPTION E O VALOR SELECIONADO É UM STRING
        if (options !== null && options.length >= 1 && typeof value === 'string') {
          // PEGA O VALOR DO CAMPO
          var valor = options.filter((option) => { return option[this.campos[chave].keyValue] === value })

          // SETA O VALOR ENCONTRADO
          value = valor.length === 1 ? valor[0] : value
        }

        // SETA O VALOR ATUALIZADO DO CAMPO
        this.$set(this.campos[chave], 'value', value)
        this.$set(this.campos[chave], 'valueIni', valueIni)
        this.$set(this.campos[chave], 'valueRef', valueRef)

        // VERIFICA SE TEM VALOR PARA ATUALIZAR
        if (options !== null) {
          this.$set(this.campos[chave], 'options', options)
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      proFormEstAjusteNovoOnChangeValue: function (value, id) {
        // PEGA O NOME DO CAMPO QUE ESTÁ SENDO ALTERADO
        var indexF = id.split('--')

        // SETA O VALOR RECEBIDO
        this.campos[indexF[1]].value = value

        // LIMPA O CAMPO DE MENSAGEM DE ERRO
        this.campos[indexF[1]].mensagem = ''

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // MANDA REMOVER A MENSAGEM DE ERRO DA ABA
        this.$emit('PRODUTO_FORMULARIO_REMOVER_ERRO', id)

        // VERIFICA A AÇÃO QUE DEVE REALIZAR
        switch (indexF[1]) {
          case 'qtde_ajuste':
            // CHAMA A FUNÇÃO PARA VERIFICAR OS NOMES
            this.proFormEstAjusteNovoTratarNomeCampo()

            // CHAMA A FUNÇÃO PARA ATUALIZAR OS VALORES
            if (this.campos[indexF[1]].trava === null) {
              this.proFormEstAjusteNovoCalcularEstoqueValor()
            }
            break

          case 'qtde_estoque':
            // CHAMA A FUNÇÃO PARA ATUALIZAR OS VALORES
            if (this.campos[indexF[1]].trava === null) {
              this.proFormEstAjusteNovoCalcularAjusteEstoqueValor()
            }
            break
        }
      },
      proFormEstAjusteNovoPegarValorCampo: function (chave) {
        // INICIA A VARIAVEL
        var valor = ''

        // VERIFICA SE TEM VALOR
        if ([ '', null, undefined ].indexOf(this.campos[chave].value) !== -1) {
          // PEGA O VALOR DO CAMPO
          valor = JSON.parse(JSON.stringify(this.campos[chave].value))

          // PEGA O VALOR SELECIONADO
          if (typeof valor !== 'string') {
            valor = valor[this.campos[chave].keyValue]
          }
        }

        // RETORNA O VALOR SOLICITADO
        return valor.toString()
      },
      proFormEstAjusteNovoInserir: function () {
        // IMPORTA A FUNÇÃO QUE SERÁ UTILIZADA
        const FUN_MONTAR_FORMDATA_API = require('@/assets/js/Funcoes-Gerais.js').FUN_MONTAR_FORMDATA_API

        // FAZ A VERIFICAÇÃO E MONTAGEM DO FORMULARIO
        FUN_MONTAR_FORMDATA_API(this.campos).then((formData) => {
          // INICIA A VARIAVEL
          var valida = ''

          // VERIFICA SE A DATA ESTÁ PREENCHIDA
          if ([ '', null, undefined ].indexOf(this.campos.est_mov_data.value) !== -1) {
            // SETA A MENSAGEM DE ERRO
            this.campos.est_mov_data.mensagem = 'É necessario preencher a data da movimentação.'

            // MUDA O VALOR DO ERRO
            if (valida === '') {
              valida = 'est_mov_data'
            }
          }

          // VERIFICA SE A DATA ESTÁ PREENCHIDA
          if ([ '', null, undefined ].indexOf(this.campos.est_mov_hora.value) !== -1 || [ '', null, undefined ].indexOf(this.campos.est_mov_hora.value.id) !== -1) {
            // SETA A MENSAGEM DE ERRO
            this.campos.est_mov_hora.mensagem = 'É necessario preencher a hora da movimentação.'

            // MUDA O VALOR DO ERRO
            if (valida === '') {
              valida = 'est_mov_hora'
            }
          }

          // VERIFICA SE A DATA ESTÁ PREENCHIDA
          if ([ '', null, undefined ].indexOf(this.campos.est_mov_minu.value) !== -1 || [ '', null, undefined ].indexOf(this.campos.est_mov_minu.value.id) !== -1) {
            // SETA A MENSAGEM DE ERRO
            this.campos.est_mov_minu.mensagem = 'É necessario preencher o minuto da movimentação.'

            // MUDA O VALOR DO ERRO
            if (valida === '') {
              valida = 'est_mov_minu'
            }
          }

          // VERIFICA SE valida PELA VERIFICAÇÃO
          if (valida === '') {
            // // SETA OS DADOS NO FORMULARIO
            formData.estoque_data_movimento = this.campos.est_mov_data.value + ' ' + this.campos.est_mov_hora.value.id + ':' + this.campos.est_mov_minu.value.id + ':00'

            // VERIFICA SE TEM REGISTRO SALVO JÁ
            if ([ '', null, undefined, '0', 0 ].indexOf(this.cpntIdPro) === -1) {
              // SETA O STATUS DE CARREGANDO DO BOTÃO
              this.botoes.salvar.status = 'carregando'
              this.botoes.cancelar.status = 'carregando'

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              this.time = new Date().getTime()

              // SETA O METHOD QUE DEVE CHAMAR
              var method = Number(this.cpntId) >= 1 ? 'PUT' : 'POST'

              // SETA A FUNÇÃO PARA FINALIZAÇÃO DO PROCESSO
              const finalizacao = () => {
                // SETA O STATUS DE CARREGANDO DO BOTÃO
                this.botoes.salvar.status = ''
                this.botoes.cancelar.status = ''

                // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                this.time = new Date().getTime()
              }

              // SETA O ID DO REGISTRO QUE ESTÁ SENDO EDITADO
              formData.id = this.cpntId

              // SETA O ID DO REGISTRO QUE ESTÁ SENDO EDITADO
              formData.id_pro = this.cpntIdPro

              // CONVERTE O VALOR EM LOT
              formData = { lot: [ formData ] }

              // COMUNICA COM A API
              this.$store.state.comunicaAPI('/produto/estoque/ajuste', method, formData, (retorno) => {
                // PEGA O VALOR RECEBIDO
                retorno = [ '', null, undefined ].indexOf(retorno.lot) === -1 ? retorno.lot[0] : { code: '200', message: retorno.message }
      
                // VERIFICA SE DEU ERRO E RETORNA OS VALORES ORIGINAL DO CAMPO
                if (retorno.code !== '200') {
                  this.proFormEstAjusteNovoTratarValidacao(retorno.message, retorno.code, finalizacao)
                } else {
                  // APRESENTA A MENSAGEM DE SUCESSO
                  this.$store.state.TRATAR_RET_LOT_API(retorno)

                  // FECHA A DIALOG
                  this.proFormEstAjusteNovoFechar(true)

                  // CHAMA A FUNÇÃO PARA ATUALIZAR A TABELA
                  this.$emit('ATUALIZAR_TABELA')

                  // SETA COM A ATUALIZAÇÃO 
                  this.$emit('ATUALIZAR_INFORMACOES_EXTERNAS')
                }
              }, this.proFormEstAjusteNovoSetarStatusGeral)
            } else {
              // REALIZA O COMANDO PARA ATUALIZAR O ARQUIVO INICIAL DO FORMULARIO
              this.$emit('PRODUTO_AJUSTE_ESTOQUE', formData)
  
              // MANDA FECHAR A DIALOG
              this.proFormEstAjusteNovoFechar(true, formData)

              // CHAMA A FUNÇÃO PARA ATUALIZAR A TABELA
              this.$emit('ATUALIZAR_TABELA')
              this.$parent.$emit('ATUALIZAR_TABELA')
            }
          } else {
            // SETA O FOCUS NO CAMPO
            this.proFormEstAjusteNovoRealizarFocusCampo(valida)

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          }
        })
      },
      proFormEstAjusteNovoRealizarFocusCampo: function (campo, tentativa = 0) {
        if (tentativa <= 10) {
          // SETA A FUNÇÃO DE REINICIAR
          var reiniciar = () => { setTimeout(() => { this.proFormEstAjusteNovoRealizarFocusCampo(campo, (tentativa + 1)) }, 100) }

          // VERIFICA SE O CAMPO EXISTE
          if (tentativa >= 2 && [ '', null, undefined ].indexOf(this.$refs[campo]) === -1) {
            // PEGA O ELEMENTO QUE DEVE DAR FOCUS
            var elemento = Array.isArray(this.$refs[campo]) === true ? this.$refs[campo][0] : this.$refs[campo]

            // VERIFICA SE O ELEMENTO EXISTE
            if ([ '', null, undefined ].indexOf(elemento) === -1 && [ '', null, undefined ].indexOf(elemento.cpntRealizarFocus) === -1 && typeof elemento.cpntRealizarFocus === 'function') {
              elemento.cpntRealizarFocus()
            } else {
              reiniciar()
            }
          } else {
            reiniciar()
          }
        }
      },
      proFormEstAjusteNovoTratarValidacao: function (apiValid, apiStatus = 400, callback = null) {
        // IMPORTA A FUNÇÃO QUE SERÁ UTILIZADA
        const FUN_TRATAR_VALIDACAO_API = require('@/assets/js/Funcoes-Gerais.js').FUN_TRATAR_VALIDACAO_API

        // FAZ A VERIFICAÇÃO E MONTAGEM DO FORMULARIO
        FUN_TRATAR_VALIDACAO_API(apiValid, apiStatus, this.campos, this).then(() => {
          if (callback !== null && typeof callback === 'function') {
            callback()
          }
        })
      },
      proFormEstAjusteNovoTratarNomeCampo: function () {
        if ([ '', null, undefined ].indexOf(this.cpntProduto) === -1 && Object.keys(this.cpntProduto).length >= 1) {
          // PEGA O VALOR DO CAMPO
          var valor = this.campos.qtde_ajuste.value
  
          // Verifica se o número é negativo
          let negativo = false;
          if (valor.charAt(0) === '-') {
            negativo = true
            valor = valor.slice(1)
          }
  
          // VERIFICA O VALOR QUE DEVE SETAR
          if (negativo !== true) {
            this.campos.valor_unitario.nome = 'Valor do fornecedor'
            valor = this.cpntProduto.valor_for
          } else {
            this.campos.valor_unitario.nome = 'Valor de venda'
            valor = this.cpntProduto.valor_ven
            // valor = (Number(this.cpntProduto.valor_ven) * 100).toFixed(0)
          }
          
          // FAZ A SEPARAÇÃO PARA SABER QUANTAS CASAS DECIMAIS TERÁ
          var value = JSON.parse(JSON.stringify(valor)).split('.')
          
          // VERIFICA SE DEVE ATIVAR A CASA DECIMAL OU NÃO
          this.$refs.valor_unitario.usarDecimal = (value.length === 2 && value[1].length >= 3)

          // FORMATA O NUMERO RECEBIDO
          this.campos.valor_unitario.value = this.$store.state.FUN_MASK_VALOR('valorDecimalNovo', valor)

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
        }
      },
      proFormEstAjusteNovoConverteEmNumero: function (valor) {
        if (isNaN(valor) !== false) {
          // REMOVE OS PONTOS DA STRING
          while (valor.indexOf('.') !== -1) {
            valor = valor.replace('.', '')
          }
          // REMOVE A VIRGULA DA STRING
          while (valor.indexOf(',') !== -1) {
            valor = valor.replace(',', '.')
          }
        }

        // RETONRA O VALOR SOLICITADO
        return Number(valor)
      },
      proFormEstAjusteNovoCalcularEstoqueValor: function () {
        // LIMPA O STOP DO CAMPO
        clearTimeout(this.campos.qtde_estoque.trava)
        this.campos.qtde_estoque.trava = null

        // PEGA O VALOR DO CAMPO
        var ajuste = JSON.parse(JSON.stringify(this.campos.qtde_ajuste.value))

        // CARREGA O VALOR DO CAMPO
        ajuste = this.proFormEstAjusteNovoConverteEmNumero(ajuste)

        // PEGA O VALOR DO CAMPO
        var estoque = JSON.parse(JSON.stringify(this.cpntProduto.virtual_qtde_estoque.estoque))

        // CALCULA O ESTOQUE
        if ([ '', null, undefined, '0', 0 ].indexOf(this.cpntId) === -1) {
          estoque = (Number(this.cpntProduto.virtual_qtde_estoque.estoque) - Number(this.campos.qtde_ajuste.valueIni)).toString()
        }

        // CARREGA O VALOR DO CAMPO
        estoque = this.proFormEstAjusteNovoConverteEmNumero(estoque)

        // CALCULA O RESULTADO
        var resultado = (estoque + ajuste)

        // VERIFICA SE É UM NUMERO, SE FOR CONVERTE PARA STRING
        if (isNaN(resultado) === false) {
          // CONVERTE O VALOR EM STRING
          resultado = Number(resultado).toString()

          // ALTERA O PONTO PARA VIRGULA
          while (resultado.indexOf('.') !== -1) {
            resultado = resultado.replace('.', ',')
          }
        }

        // // FORMATA O NUMERO RECEBIDO
        // resultado = this.$store.state.FUN_MASCARA_VALOR('VALOR_DECIMAL_CAMPO', resultado.toString())

        // FORMATA O VALOR CALCULADO
        this.campos.qtde_estoque.value = resultado
        
        // LIMPA O STOP DO CAMPO
        this.campos.qtde_estoque.trava = setTimeout(() => {
          // LIMPA O STOP DO CAMPO
          clearTimeout(this.campos.qtde_estoque.trava)
          this.campos.qtde_estoque.trava = null
        }, 1000)

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      proFormEstAjusteNovoCalcularAjusteEstoqueValor: function () {
        // LIMPA O STOP DO CAMPO
        clearTimeout(this.campos.qtde_ajuste.trava)
        this.campos.qtde_ajuste.trava = null

        // PEGA O VALOR DO CAMPO
        var resultado = JSON.parse(JSON.stringify(this.campos.qtde_estoque.value))

        // CARREGA O VALOR DO CAMPO
        resultado = this.proFormEstAjusteNovoConverteEmNumero(resultado)

        // PEGA O VALOR DO CAMPO
        var estoque = JSON.parse(JSON.stringify(this.cpntProduto.virtual_qtde_estoque.estoque))

        // CALCULA O ESTOQUE
        if ([ '', null, undefined, '0', 0 ].indexOf(this.cpntId) === -1) {
          estoque = (Number(this.cpntProduto.virtual_qtde_estoque.estoque) - Number(this.campos.qtde_ajuste.valueIni)).toString()
        }

        // CARREGA O VALOR DO CAMPO
        estoque = this.proFormEstAjusteNovoConverteEmNumero(estoque)

        // CALCULA O RESULTADO
        var ajuste = resultado - estoque

        // VERIFICA SE É UM NUMERO, SE FOR CONVERTE PARA STRING
        if (isNaN(ajuste) === false) {
          // CONVERTE O VALOR EM STRING
          ajuste = Number(ajuste).toString()

          // ALTERA O PONTO PARA VIRGULA
          while (ajuste.indexOf('.') !== -1) {
            ajuste = ajuste.replace('.', ',')
          }
        }
        
        // // FORMATA O NUMERO RECEBIDO
        // ajuste = this.$store.state.FUN_MASCARA_VALOR('VALOR_DECIMAL_CAMPO', ajuste.toString())

        // FORMATA O VALOR CALCULADO
        this.campos.qtde_ajuste.value = ajuste

        // LIMPA O STOP DO CAMPO
        this.campos.qtde_ajuste.trava = setTimeout(() => {
          // LIMPA O STOP DO CAMPO
          clearTimeout(this.campos.qtde_ajuste.trava)
          this.campos.qtde_ajuste.trava = null
        }, 1000)

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      }
    }
  }
</script>  


